// Um die normale route Struktur nicht zu stören: 'al-' + alias

export const aliases = {
	admin_report: [
		'/al-admin-reports/:id',
		'/administration/management/pending_requests/updaterequests/reports/:id',
		// '/pending_requests/reports/:id'
	],
	user_report: ['/al-user-reports/:id?', '/profile/reports/:id?'],
	update_request: [
		'/al-update-requests/:id',
		'/administration/management/pending_requests/updaterequests/:id',
		'/administration/management/updaterequests/:id',
		// '/pending_requests/updaterequests/',
	],
	sync_update: ['/al-sync-updates/:id', '/administration/management/syncs/:id'],
	password_set: ['/al-password-set/:token'],
	building: [
		// '/al-buildings/:id'
		// '/buildings/:id'
	],
	document: [
		'/al-documents/:id',
		// '/documents/:id'
	],
	review_document: [
		'/al-review-documents/::reviewDocumentId',
		// '/review_documents/:id'
	],
}

export function convertAliasesToRegex(aliases: Record<string, string[]>) {
	const result: Record<string, string[]> = {}

	for (const key in aliases) {
		const paths = aliases[key]

		result[key] = paths
			.filter(
				(path) => typeof path === 'string' && !path.trim().startsWith('//')
			)
			.map((path) => {
				const regexPath = path.replace(/:([^/]+)/g, '.*')
				return `^${regexPath}$`
			})
	}

	return result
}
